import {Injectable} from '@angular/core';

export const LANG: string = "LANG";
export const JWT_RESPONSE: string = "JWT_RESPONSE";

@Injectable({ providedIn:'root' })
export class LocalStorageService {

  public saveData(key: string, value: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, value);
    }
  }

  public getData(key: string) {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(key);
    } else {
      return undefined;
    }
  }

  public removeData(key: string) {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key);
    }
  }

  public clearData() {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }
}
